import DeletePolicy from "./DeletePolicy";
export default DeletePolicy;
